import { IconProps } from "./Icons";

export const IconPatientInfo = ({
  width = 24,
  height = 24,
  color = "white",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
  >
    <g clipPath="url(#clip0_4501_2813)" filter="url(#filter0_i_4501_2813)">
      <path
        d="M12 21.6582C16.9706 21.6582 21 17.6288 21 12.6582C21 7.68764 16.9706 3.6582 12 3.6582C7.02944 3.6582 3 7.68764 3 12.6582C3 17.6288 7.02944 21.6582 12 21.6582Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.6582C14.0711 15.6582 15.75 13.9793 15.75 11.9082C15.75 9.83714 14.0711 8.1582 12 8.1582C9.92893 8.1582 8.25 9.83714 8.25 11.9082C8.25 13.9793 9.92893 15.6582 12 15.6582Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.98145 19.3491C6.54574 18.2376 7.40678 17.3041 8.46914 16.652C9.5315 16 10.7537 15.6548 12.0002 15.6548C13.2467 15.6548 14.4689 16 15.5312 16.652C16.5936 17.3041 17.4547 18.2376 18.0189 19.3491"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_4501_2813"
        x="0"
        y="0.658203"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="122" dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_4501_2813"
        />
      </filter>
      <clipPath id="clip0_4501_2813">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.658203)"
        />
      </clipPath>
    </defs>
  </svg>
);
